import { defineMessages } from "react-intl";
const messages = defineMessages({
    magicButtonSuccessCreation: {
        id: "app.admin.addMagicButton.title.text",
        defaultMessage: "Magic Button successfully created",
    },
    magicButtonTitle: {
        id: "app.admin.magicButtonTitle.title.text",
        defaultMessage: "Create Magic Button",
    },
    magicButtonTemplateRequired: {
        id: "app.admin.magicButtonTemplate.required.text",
        defaultMessage: "Website Vendor is required",
    },
    magicButtonCommunityRequired: {
        id: "app.admin.magicButtonCommunity.required.text",
        defaultMessage: "Community is required",
    },
    magicButtonWebsiteUrlRequired: {
        id: "app.admin.magicButtonWebsiteUrl.required.text",
        defaultMessage: "Website URL is required",
    },
    magicButtonWebsiteUrlFormat: {
        id: "app.admin.magicButtonWebsiteUrlFormat.required.text",
        defaultMessage: "Website URL must be a valid URL",
    },
    magicButtonScriptNameRequired: {
        id: "app.admin.magicButtonScriptNameRequired.required.text",
        defaultMessage: "Script Name is required",
    },
    template: {
        id: "app.admin.magicButtonTemplate.label.text",
        defaultMessage: "Website Type",
    },
    community: {
        id: "app.admin.magicButtonCommunity.label.text",
        defaultMessage: "Community",
    },
    websiteUrl: {
        id: "app.admin.magicButtonWebsiteUrl.label.text",
        defaultMessage: "Website URL",
    },
    scriptName: {
        id: "app.admin.magicButtonScriptName.label.text",
        defaultMessage: "Script Name",
    },
    noTemplateSelected: {
        id: "app.admin.magicButtonTemplate.noTemplateSelected.text",
        defaultMessage: "Select a website vendor to preview its content",
    },
    floorPlanScreenshot: {
        id: "app.admin.magicButtonTemplate.floorPlanScreenshot.text",
        defaultMessage: "Floor Plan Layout Screenshot",
    },
    unitScreenshot: {
        id: "app.admin.magicButtonTemplate.unitScreenshot.text",
        defaultMessage: "Unit Layout Screenshot",
    },
    testingScript: {
        id: "app.admin.magicButtonTemplate.testingScript.text",
        defaultMessage: "Testing Script",
    },
    magicButtonScriptNameRegex: {
        id: "app.admin.magicButtonScriptNameRegex.text",
        defaultMessage: "Script Name must start with a letter and contain only letters, numbers, and underscores",
    },
    magicButtonConfirmationText: {
        id: "app.admin.magicButtonConfirmationText.text",
        defaultMessage: "Have you tested this script on both the unit and floorplan pages? We do not 100% guarantee that the Magic Button will work on this site if it is not property tested.",
    },
    magicButtonConfirmationLinkText: {
        id: "app.admin.magicButtonConfirmationLinkText.text",
        defaultMessage: "Steps to test a Magic Button script:",
    },
    magicButtonConfirmationNoButton: {
        id: "app.admin.magicButtonConfirmationNoButton.text",
        defaultMessage: "No, I have not tested this script",
    },
    magicButtonConfirmationYesButton: {
        id: "app.admin.magicButtonConfirmationYesButton.text",
        defaultMessage: "Yes, I have tested this script",
    },
});
export default messages;
